"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.iterator.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/esnext.iterator.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Search = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search.svg"));
var _chevron_up = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron_up.svg"));
var _chevron_down = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron_down.svg"));
var _Close = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Close.svg"));
var _helpers = require("../../SVBAPICards/src/js/helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SVBFilter = props => {
  const {
    tableColumnData,
    filteredResult
  } = props;
  const [menuListShow, setmenuListShow] = (0, _react.useState)(false);
  const [isClearAll, setIsClearAll] = (0, _react.useState)(true);
  const [labelVal, setLebelVAl] = (0, _react.useState)("");
  const [searchVal, setSearchVal] = (0, _react.useState)("");
  const [formErrorMessages, setformErrorMessages] = (0, _react.useState)([]);
  const [formError, setFormError] = (0, _react.useState)(false);
  const [updatedFIlteredVal, setUpdatedFilteredVal] = (0, _react.useState)([]);
  const [dropDownSearch, setDropdownSearch] = (0, _react.useState)("");
  const dropdownRef = (0, _react.useRef)(null);

  // form Validaton
  const validateForm = formattedInputWithoutSpaces => {
    let formErrors = [];
    const regexForTags = /<[^>]*>|script|javascript/gi;
    const alphaNumPattern = /^[a-zA-Z0-9 ]*$/;
    if (labelVal === "") {
      formErrors.push("Please select label first");
    } else {
      regexForTags.test(formattedInputWithoutSpaces) && formErrors.push("Must not consist any tags");
      formattedInputWithoutSpaces.length < 1 && formErrors.push("Must be at least 1 characters long");
      !alphaNumPattern.test(formattedInputWithoutSpaces) && formErrors.push("Must not have any symbols");
    }
    if (formErrors.length > 0) setFormError(true);
    // else if (labelVal === '') setFormError(true);
    else setFormError(false);
    return formErrors;
  };

  // handle submit
  const submitHandler = searchedVal => {
    let submittedVal;
    if (searchedVal && searchedVal.target) {
      if (searchedVal.key == "Enter") {
        submittedVal = searchedVal.target.value;
      }
    } else {
      submittedVal = searchedVal;
    }
    const validateFormErrorReturn = validateForm(submittedVal);
    if (validateFormErrorReturn && validateFormErrorReturn.length > 0) {
      setformErrorMessages(validateFormErrorReturn);
      return;
    } else {
      const updatedFilterVal = [...updatedFIlteredVal, {
        label: labelVal,
        value: submittedVal,
        id: (0, _helpers.slugCreator)(labelVal + submittedVal)
      }];
      const uniqueUpdatedFilterVal = Object.values(updatedFilterVal.reduce((acc, obj) => _objectSpread(_objectSpread({}, acc), {}, {
        [obj.id]: obj
      }), {}));
      setUpdatedFilteredVal(uniqueUpdatedFilterVal);
      filteredResult(uniqueUpdatedFilterVal);
      setLebelVAl("");
      setSearchVal("");
    }
    setIsClearAll(true);
  };

  //  dropdown hide/show
  const handleFilterMenu = () => {
    setmenuListShow(!menuListShow);
    setDropdownSearch("");
  };

  // handle clearAll
  const handleClearAll = () => {
    setIsClearAll(false);
    setUpdatedFilteredVal([]);
    filteredResult([]);
  };

  // handle dropdown select
  const handleSelectLabel = val => {
    setLebelVAl(val);
    setmenuListShow(false);
    setDropdownSearch("");
  };

  // remove selected value
  const handleremoveFilteredVAl = id => {
    const updatedFilteredresult = updatedFIlteredVal.filter(item => {
      return item.id !== id;
    });
    setUpdatedFilteredVal(updatedFilteredresult);
    filteredResult(updatedFilteredresult);
  };
  (0, _react.useEffect)(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setmenuListShow(false);
        setDropdownSearch("");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const filteredDropdown = dropDownSearch.length === 0 ? tableColumnData : tableColumnData.filter(item => item.toLowerCase().includes(dropDownSearch.toLowerCase()));
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "svb-mw-filter",
    className: "filter-main-wrapper my-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mw-filter-container d-flex mb-4 align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mw-title heading-small pe-4"
  }, "Filter by :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mw-label-select-dropdown pe-4",
    ref: dropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleFilterMenu,
    className: "filter-dropdown-search d-flex flex-row px-2",
    role: "button"
  }, /*#__PURE__*/_react.default.createElement("input", {
    readOnly: true,
    value: labelVal,
    onFocus: e => e.target.blur(),
    type: "text",
    role: "button",
    placeholder: "Select Label",
    className: "border-0 p-0 w-100 paragraph m-0"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: menuListShow ? _chevron_up.default : _chevron_down.default,
    className: "d-flex filter-icon align-self-center"
  })), menuListShow && /*#__PURE__*/_react.default.createElement("div", {
    className: "mw-dropdown-label-list position-relative"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-list-container position-absolute py-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-innersearch d-flex mx-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex px-2"
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: dropDownSearch,
    onChange: e => setDropdownSearch(e.target.value),
    type: "text",
    placeholder: "Type Label",
    className: "border-0 p-0 w-100 paragraph m-0"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Search.default,
    className: "d-flex filter-icon align-self-center"
  }))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "p-0 m-0 "
  }, filteredDropdown === null || filteredDropdown === void 0 ? void 0 : filteredDropdown.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: "mw-dropdown-item-list",
      onClick: () => handleSelectLabel(item)
    }, item);
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "filters-search filter-search mw-outer-search-box d-flex flex-row position-relative"
  }, formError && /*#__PURE__*/_react.default.createElement("span", {
    className: "invalid-feedback d-block position-absolute"
  }, formErrorMessages.join(" and ")), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      var _e$target$;
      e.preventDefault();
      submitHandler((_e$target$ = e.target[0]) === null || _e$target$ === void 0 ? void 0 : _e$target$.value);
    },
    className: "d-flex w-100 pe-2"
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: searchVal,
    onChange: e => setSearchVal(e.target.value),
    type: "text",
    placeholder: "Enter Value",
    className: "border-0 p-0 w-100 paragraph m-0 ps-2"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Search.default,
    className: "d-flex align-self-center",
    width: "18",
    height: "18",
    onClick: () => submitHandler(searchVal),
    alt: "search keyword icon"
  })))), isClearAll && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, updatedFIlteredVal.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex pe-4",
      key: index,
      id: item.id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "filtered-selected-wrapper d-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "filtered-tag-selected"
    }, item.label, " : "), /*#__PURE__*/_react.default.createElement("div", {
      className: "filtered-tag-searched"
    }, " ", item.value), /*#__PURE__*/_react.default.createElement("img", {
      src: _Close.default,
      className: "d-flex filter-icon align-self-center",
      onClick: () => handleremoveFilteredVAl(item.id),
      alt: "remove-filter-".concat(item.id)
    })));
  }), Object.keys(updatedFIlteredVal).length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "filtered-tag-searched",
    onClick: handleClearAll
  }, "Clear All")));
};
var _default = exports.default = SVBFilter;